import "./App.css";
import { Route, Routes, Navigate } from "react-router-dom";
import LayOut from "./PageComponent/LayOut";
import Home from "./PageComponent/Home";
import Camcorder from "./PageComponent/CamCorder";
import Photodiary from "./PageComponent/PhotoDiary";
import Login from "./PageComponent/Login";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import "./Font/Font.css";
import ProtectedRoute from "./Routes/ProtectedRoute";
import { TokenAtom } from "./Hooks/TokenAtom";
import AuthHandler from "./PageComponent/AuthHandler";
import { useRecoilValue } from "recoil";
import { useEffect, useState } from "react";
import LoadingSpinner from "./LoadingComponent/LoadingSpinner";
import firebase from "firebase/app";
import "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDR8Li_1fcfTSVRG0WI-EnBv26xRctMKAw",
  authDomain: "album-login-c9f53.firebaseapp.com",
  projectId: "album-login-c9f53",
  storageBucket: "album-login-c9f53.appspot.com",
  messagingSenderId: "687062425763",
  appId: "1:687062425763:web:91c924f282c66d5b069f16",
};
firebase.initializeApp(firebaseConfig);

export function getDeviceType() {
  const userAgent = navigator.userAgent;

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  } else if (/Android/.test(userAgent)) {
    return "Android";
  } else {
    return "Other";
  }
}

const deviceType = getDeviceType();

// Firebase 초기화

const darkTheme = createTheme({
  // palette: {
  //   mode: 'dark',
  // },
  typography: {
    fontFamily: "LeeSeoyun, sans-serif",
  },
});

function App() {
  const tokens = useRecoilValue(TokenAtom);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (deviceType !== "iOS") {
      const messaging = firebase.messaging();

      if ("serviceWorker" in navigator) {
        navigator.serviceWorker
          .register("/firebase-messaging-sw.js")
          .then(function (registration) {})
          .catch(function (error) {
            console.log("Service Worker registration failed:", error);
          });
      }

      // 사용자에게 알림 권한 요청
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          // 토큰 받기

          messaging
            .getToken({
              vapidKey:
                "BDNBOkglOcZt3UyYLAJbtX3lsqByk1Ubw-374AZ5OHgIXSpeaPGTw9NUG-MSsTmiIpIQe3M_ZUINeemaim2GAns",
            })
            .then((currentToken) => {
              if (currentToken) {
                localStorage.setItem("shootToken", currentToken);
                // setTokenpush(currentToken);
              } else {
                console.log("No registration token available.");
              }
            })
            .catch((err) => {
              console.log("An error occurred while retrieving token. ", err);
            });
        } else {
          console.log("Unable to get permission to notify.");
        }
        setLoading(false);
      });
    } else {
      localStorage.setItem("shootToken", "");
    }
  }, []);

  if (deviceType !== "iOS") {
    if (loading) {
      return <LoadingSpinner loading={loading} />;
    }
  }
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      {tokens.access && <AuthHandler />}
      <Routes>
        {/* /firebase-messaging-sw.js 경로는 리다이렉트하지 않음 */}
        <Route path="/" element={<Navigate to="/Login" replace />} />
        <Route path="/Login" element={<Login />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<LayOut />}>
            <Route path="/Home" element={<Home />} />
            <Route path="/Camcorder" element={<Camcorder />} />
            <Route path="/Photodiary" element={<Photodiary />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/Login" replace />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
